export const firebaseConfig = {
    apiKey: "AIzaSyBqKYdurVcGZmwtsI2gdREWFkzh0JUmTuc",
    authDomain: "tiny-piggy-bank.firebaseapp.com",
    projectId: "tiny-piggy-bank",
    storageBucket: "tiny-piggy-bank.appspot.com",
    messagingSenderId: "193836666832",
    appId: "1:193836666832:web:07a2c6e43c402027b9f3d5"
};
